export default __webpack_public_path__ + "static/media/twitter.763ddc74.svg";